<template>
  <div id="termsAndConditionsPopUp" class="cardPopUp">
    <div class="cardBody tandcContainer">
      <div class="header">
        <a @click="close" class="closeButton">
          <i class="fas fa-times"></i>
        </a>
      </div>
      <div class="textCopy">
        <h5>Terms and Conditions</h5>
        <p>
          We use security measures to protect against the loss, misuse and alteration of data used by our
          system.
        </p>
        <p>
          We will never share, sell or rent personal information without your express permission – unless
          ordered by a court of law. Information submitted to us is only available to employees of Shaves who
          are managing this information for the purpose of contacting you, sending you emails, or for
          providing you with services relating to our loyalty programme. Should you wish to be removed from
          the database, each email sent contains an easy unsubscribe option.
        </p>
        <p>In order to protect your membership, you are required to produce your ID or the membership card.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      document.body.classList.remove("showTermsAndConditions");
    }
  }
};
</script>